const AB_ENDPOINT = "https://vps.38-3d.co.uk/analytics/AB";

function abTestHandleClick(metaObject_data, version) {
  try {
    if (typeof metaObject_data === "string") {
      metaObject_data = JSON.parse(metaObject_data);
    }
    const abTestId = metaObject_data && metaObject_data.test_id;
    if (!abTestId || !version) return;

    const data = { ab_test_id: abTestId, version, event: "clicked" };
    fetch(AB_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).catch(() => { });
  } catch (e) {
    // Silently ignore malformed metaObject_data
  }
}

function abTestHandleView(metaObject_data, version) {
  try {
    if (typeof metaObject_data === "string") {
      metaObject_data = JSON.parse(metaObject_data);
    }
    const abTestId = metaObject_data && metaObject_data.test_id;
    if (!abTestId || !version) return;

    const data = { ab_test_id: abTestId, version, event: "viewed" };
    fetch(AB_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).catch(() => { });
  } catch (e) {
    // Silently ignore malformed metaObject_data
  }
}

function pickAB() {
  const rand = Math.random();
  const version = rand < 0.5 ? "A" : "B";
  return version;
}

function getABCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

function setABCookie(name, value) {
  const days = 3;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value};expires=${expires};path=/`;
}

function abGetSeenValue(testId) {
  const abTestCookie = getABCookie("abTestCookie");
  if (!abTestCookie) return false;

  let tests;
  try {
    const decoded = atob(abTestCookie);
    tests = JSON.parse(decoded);
  } catch (e) {
    return false;
  }

  if (!Array.isArray(tests)) return false;

  for (const entry of tests) {
    if (typeof entry === "string") {
      const [id, value] = entry.split(":");
      if (id === testId && (value === "A" || value === "B")) {
        return value;
      }
    }
  }

  return false;
}

function abTestUpdateTests(testStr) {
  const cookieName = "abTestCookie";
  let abTestCookie = getABCookie(cookieName);
  let testList = [];

  if (abTestCookie) {
    try {
      const decoded = atob(abTestCookie);
      testList = JSON.parse(decoded);
      if (!Array.isArray(testList)) testList = [];
    } catch (e) {
      testList = [];
    }
  }

  if (typeof testStr === "string" && testStr.includes(":")) {
    const [name, variant] = testStr.split(":");
    if (name && (variant === "A" || variant === "B")) {
      const alreadyExists = testList.some((t) => {
        const [existingName] = String(t).split(":");
        return existingName === name;
      });
      if (!alreadyExists) {
        testList.push(`${name}:${variant}`);
      }
    }
  }

  const updatedEncoded = btoa(JSON.stringify(testList));
  setABCookie(cookieName, updatedEncoded);
}

function update_property_value(property_id) {
  const property_element = document.getElementById(property_id);
  if (!property_element) return;
  property_element.value = getABCookie("abTestCookie") || "";
}